import { render } from "./WCAccountSidebar.vue?vue&type=template&id=4113ce6f&scoped=true"
import script from "./WCAccountSidebar.vue?vue&type=script&lang=js"
export * from "./WCAccountSidebar.vue?vue&type=script&lang=js"

import "./WCAccountSidebar.vue?vue&type=style&index=0&id=4113ce6f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4113ce6f"]])

export default __exports__